import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";
import { PageHeader, SectionCard } from "../components/Shared";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";

export default function Settings() {
  const { user, refreshUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [company, setCompany] = useState(user?.company || "");
  const [emailNotif, setEmailNotif] = useState(user?.notification_email !== false);
  const [inappNotif, setInappNotif] = useState(user?.notification_inapp !== false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");

  const saveProfile = async () => {
    try {
      await api.put("/settings/profile", { name, company, notification_email: emailNotif, notification_inapp: inappNotif });
      await refreshUser();
      toast.success("Profile updated");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const changePass = async () => {
    if (!cur || nw.length < 6) { toast.error("Provide current & new password (min 6)"); return; }
    try {
      await api.put("/settings/password", { current_password: cur, new_password: nw });
      setCur(""); setNw(""); toast.success("Password changed");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6 animate-fade-in max-w-3xl">
      <PageHeader title="Settings" subtitle="Manage your account & notifications" />

      <SectionCard title="Profile information" testid="settings-profile">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Full name</Label><Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5" data-testid="settings-name" /></div>
          <div><Label>Company</Label><Input value={company} onChange={(e) => setCompany(e.target.value)} className="mt-1.5" /></div>
          <div className="md:col-span-2"><Label>Email</Label><Input value={user?.email || ""} disabled className="mt-1.5 bg-zinc-50" /></div>
        </div>
        <Button className="mt-4 bg-[#6366F1] hover:bg-[#4F46E5]" onClick={saveProfile} data-testid="settings-save-profile">Save changes</Button>
      </SectionCard>

      <SectionCard title="Notifications">
        <div className="space-y-3">
          <div className="flex items-center justify-between"><div><div className="font-medium text-sm">Email notifications</div><div className="text-xs text-zinc-500">RFQ updates, document expiry, onboarding</div></div><Switch checked={emailNotif} onCheckedChange={setEmailNotif} data-testid="toggle-email-notif" /></div>
          <div className="flex items-center justify-between"><div><div className="font-medium text-sm">In-app notifications</div><div className="text-xs text-zinc-500">Show notification bell alerts</div></div><Switch checked={inappNotif} onCheckedChange={setInappNotif} /></div>
        </div>
        <Button className="mt-4 bg-[#6366F1] hover:bg-[#4F46E5]" onClick={saveProfile}>Save preferences</Button>
      </SectionCard>

      <SectionCard title="Change password">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Current password</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1.5" /></div>
          <div><Label>New password</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1.5" /></div>
        </div>
        <Button className="mt-4 bg-[#6366F1] hover:bg-[#4F46E5]" onClick={changePass} data-testid="settings-change-pass">Update password</Button>
      </SectionCard>
    </div>
  );
}
